"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const silo_style_1 = __importDefault(require("../silo.style"));
const silo_action_1 = __importDefault(require("../silo.action"));
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const grid_1 = __importDefault(require("components/templates/grid"));
const modal_1 = require("components/molecules/modal");
const silo_column_1 = require("../silo.column");
const SiloHistory = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { dataStatesHistory, mutationMode, dataHistory, dataHauler, dataItem } = (0, store_1.useAppSelector)((state) => state.silo);
    const { configurationCheckPointData: dataPos } = (0, store_1.useAppSelector)((state) => state.siloPos);
    const onClickHandle = (event) => {
        dispatch(silo_action_1.default.onClickMutation({ mutationMode: 'details', dataItem: event.dataItem }));
    };
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { skip: types === 'page' ? (val - 1) * dataStatesHistory.take : 0, take: types === 'take' ? val : dataStatesHistory.take, filter: {
                logic: 'and',
                filters: [{
                        operator: 'uuid',
                        field: 'checkpoint_id',
                        value: dataPos.checkpoint_id
                    }]
            } });
        dispatch(silo_action_1.default.onDataStateChangeHistory(newDataStates));
    };
    const onSortChange = (e) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { sort: e.sort });
        dispatch(silo_action_1.default.onSortChange(e.sort));
        dispatch(silo_action_1.default.getDataHistory(newDataStates));
    };
    const onFilterChange = (e) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { filter: e.filter });
        dispatch(silo_action_1.default.onFilterChange(e.filter));
        dispatch(silo_action_1.default.getDataHistory(newDataStates));
    };
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal, Object.assign({ appTheme: appTheme, modalTitle: 'History', show: mutationMode == 'history', style: silo_style_1.default.modalContainer(appTheme), handleClose: () => {
            dispatch(silo_action_1.default.onClickMutation({ mutationMode: false, dataHauler, dataItem }));
        } }, { children: (0, jsx_runtime_1.jsx)(grid_1.default, { cardGrid: false, pageable: true, sortable: true, scrollable: dataStatesHistory.scrollable, sort: dataStatesHistory.sort, dataStates: dataStatesHistory, style: silo_style_1.default.gridHeight, dataGrid: dataHistory, columns: silo_column_1.siloHistoryColumnProps, onRowClick: (event) => onClickHandle(event), onPageChange: (v) => onDataStateChange('page', v), onTakeChange: (v) => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange }) })));
};
exports.default = SiloHistory;
